import { gql } from '@apollo/client';

const GET_FLOATING_BANNER = gql`
  query getFloatingBanner($slug: String!) {
    sectionsBy(slug: $slug) {
      floatingBanner {
        position
        transition
        bannerImage {
          node {
            altText
            title
            mediaItemUrl
          }
        }
      }
    }
  }
`;

export { GET_FLOATING_BANNER }